import blog_1 from "./base/blog_1.jpg";
import blog_2 from "./base/blog_2.jpg";
import blog_3 from "./base/blog_3.jpg";
import blog_4 from "./base/blog_4.jpg";
import blog_5 from "./base/blog_5.jpg";
import blog_6 from "./base/blog_6.jpg";
import blog_7 from "./base/blog_7.jpg";
import blog_8 from "./base/blog_8.jpg";
import blog_9 from "./base/blog_9.jpg";
import icon_green from "./base/icon_green.svg";
import icon_blue from "./base/icon_blue.svg";
import icon_red from "./base/icon_red.svg";
import gobluebird from "./base/gobluebird.png";
import jago from "./base/jago.png";
import goinvestasi from "./base/goinvestasi.svg";

const image = {
  blog_1: blog_1,
  blog_2: blog_2,
  blog_3: blog_3,
  blog_4: blog_4,
  blog_5: blog_5,
  blog_6: blog_6,
  blog_7: blog_7,
  blog_8: blog_8,
  blog_9: blog_9,
  icon_green: icon_green,
  icon_blue: icon_blue,
  icon_red: icon_red,
  jago: jago,
  gobluebird: gobluebird,
  goinvestasi: goinvestasi,
};

export default image;
